export default "__VITE_ASSET__e5809d0f__"